import {
  ORDENLABORATORIO_ERROR,
  ORDENLABORATORIO_LOADING,
  ORDENLABORATORIO_SUCCESS,
  ORDENLABORATORIO_RESET,
  ORDENLABORATORIO_ELIMINAR,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import ordenLaboratorioInitialState from "../initialStates/ordenLaboratorioInitialState";

const ordenLaboratorio = (state, { payload, type }) => {
  switch (type) {
    case ORDENLABORATORIO_LOADING:
      return {
        ...state,
        ordenLaboratorio: {
          ...state.ordenLaboratorio,
          error: false,
          loading: true,
        },
      };
    case ORDENLABORATORIO_SUCCESS:
      return {
        ...state,
        ordenLaboratorio: {
          ...state.ordenLaboratorio,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case ORDENLABORATORIO_ERROR:
      return {
        ...state,
        ordenLaboratorio: {
          ...state.ordenLaboratorio,
          error: payload,
          loading: false,
        },
      };

    case ORDENLABORATORIO_ELIMINAR:
      return {
        ...state,
        ordenLaboratorio: {
          ...state.ordenLaboratorio,
          loading: false,
          error: false,
          eliminado: payload,
        },
      };

    case ORDENLABORATORIO_RESET:
      return ordenLaboratorioInitialState;
    case RESET_PORTAL_CONTEXT:
      return ordenLaboratorioInitialState;

    default:
      return state;
  }
};

export default ordenLaboratorio;
